import { useCallback, useMemo } from "react";
import { useLocation, useNavigate, NavigateOptions } from "react-router-dom";


export const useRouteHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const moveToScenarioPage = useCallback((options?: NavigateOptions) => {
        navigate("/scenarios", options);
    }, [navigate]);

    const moveToDashboard = useCallback((scenarioId: string, options?: NavigateOptions) => {
        navigate(`/scenarios/${scenarioId}/dashboard`, options);
    }, [navigate]);

    const moveToScenarioEdit = useCallback((scenarioId: string, options?: NavigateOptions) => {
        navigate(`/scenarios/${scenarioId}/scenario-edit`, options);
    }, [navigate]);

    const moveToTemplateEdit = useCallback((scenarioId: string, options?: NavigateOptions) => {
        navigate(`/scenarios/${scenarioId}/template`, options);
    }, [navigate]);

    const moveToBulkTest = useCallback((scenarioId: string) => {
        navigate(`/scenarios/${scenarioId}/test`);
    }, [navigate]);

    const moveToConversationHistory = useCallback((scenarioId: string, options?: NavigateOptions) => {
        navigate(`/scenarios/${scenarioId}/conversation`, options);
    }, [navigate]);

    const moveToIntegrationChannel = useCallback((scenarioId: string, channel: string, options?: NavigateOptions) => {
        navigate(`/scenarios/${scenarioId}/integration/${channel}`, options);
    }, [navigate]);

    const removeStateKey = useCallback((key: string) => {
        const { [key]: _, ...rest } = location.state;
        navigate(location.pathname, { state: rest, replace: true });
    }, [location, navigate]);

    const resetRoute = useCallback( () => {
        moveToScenarioPage({ replace: true });
    }, [moveToScenarioPage]);

    return useMemo(() => {
        return {
            moveToScenarioPage,
            moveToDashboard,
            moveToScenarioEdit,
            moveToTemplateEdit,
            moveToBulkTest,
            moveToConversationHistory,
            moveToIntegrationChannel,
            resetRoute,
            removeStateKey
        };
    }, [
        moveToScenarioPage,
        moveToDashboard,
        moveToScenarioEdit,
        moveToTemplateEdit,
        moveToBulkTest,
        moveToConversationHistory,
        moveToIntegrationChannel,
        resetRoute,
        removeStateKey
    ]);
};
